const CLASS_NAME_TO_FUNCTION = {}

function getDomainListPathReduxUtil (instance) {
  const { className } = instance
  const fn = CLASS_NAME_TO_FUNCTION[className]
  if (!fn) {
    return
  }
  return fn(instance)
}

export default getDomainListPathReduxUtil
